module.exports = __webpack_public_path__ + "static/media/logo.397beac1.svg";